var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 8,
    viewBox: "0 0 55 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3535 4.35356C54.5488 4.1583 54.5488 3.84171 54.3535 3.64645L51.1716 0.464471C50.9763 0.269208 50.6597 0.269208 50.4645 0.464471C50.2692 0.659733 50.2692 0.976315 50.4645 1.17158L53.2929 4L50.4645 6.82843C50.2692 7.02369 50.2692 7.34028 50.4645 7.53554C50.6597 7.7308 50.9763 7.7308 51.1716 7.53554L54.3535 4.35356ZM-4.37114e-08 4.5L54 4.5L54 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z",
    fill: "#262758"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongVector);
export default __webpack_public_path__ + "static/media/longVector.c58ccda9c8382f9e95881fbf08236bd5.svg";
export { ForwardRef as ReactComponent };